import './A2030BriefingPage.css';

import usePlansData from '../../b2b-plans/hooks/usePlansData';
import usePlansImpact from '../../b2b-frameworks/hooks/usePlansImpact';
import DashboardGrid from '../components/DashboardGrid';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import { useLoginContext } from '../../../App';

const A2030BriefingPage = () => {
    const { loginData } = useLoginContext();
    const { t } = useB2BTranslation('b2b-reporting');

    const widgetsData = [
        {
            widgetId: 1001,
            widgetType: 'ORGANIZATION',
            widgetName: t('Sustainable Organization'),
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_LOGO_NAME_WIDGET',
                acronym: 'ORGANIZATION_LOGO_NAME_WIDGET',
                row: 1,
                column: 1,
                width: 4,
                height: 2,
                extraFields: {
                    widgetStyles: {
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
        {
            widgetId: 1002,
            widgetType: 'ORGANIZATION',
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_GREEN_INDICATORS_WIDGET',
                acronym: 'ORGANIZATION_GREEN_INDICATORS_WIDGET',
                title: t('Green Indicators'),
                row: 1,
                column: 5,
                width: 2,
                height: 3,
                extraFields: {
                    widgetStyles: {
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
        {
            widgetId: 1003,
            widgetType: 'ORGANIZATION',
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_YELLOW_INDICATORS_WIDGET',
                acronym: 'ORGANIZATION_YELLOW_INDICATORS_WIDGET',
                title: t('Yellow Indicators'),
                row: 1,
                column: 7,
                width: 2,
                height: 3,
                extraFields: {
                    widgetStyles: {
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
        {
            widgetId: 1004,
            widgetType: 'ORGANIZATION',
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_RED_INDICATORS_WIDGET',
                acronym: 'ORGANIZATION_RED_INDICATORS_WIDGET',
                title: t('Red Indicators'),
                row: 4,
                column: 5,
                width: 2,
                height: 3,
                extraFields: {
                    widgetStyles: {
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
        {
            widgetId: 1005,
            widgetType: 'ORGANIZATION',
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_GREY_INDICATORS_WIDGET',
                acronym: 'ORGANIZATION_GREY_INDICATORS_WIDGET',
                title: t('No-Status Indicators'),
                row: 4,
                column: 7,
                width: 2,
                height: 3,
                extraFields: {
                    widgetStyles: {
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
        {
            dashboardId: 10000,
            widgetId: 1006,
            widgetType: 'ORGANIZATION',
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_SDGS_PIECHART_WIDGET',
                acronym: 'ORGANIZATION_SDGS_PIECHART_WIDGET',
                detectHovering: false,
                title: t('Organization SDGs Piechart Widget'),
                row: 3,
                column: 1,
                width: 4,
                height: 4,
                extraFields: {
                    size: 450,
                    widgetStyles: {
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
        {
            widgetId: 1007,
            widgetType: 'ORGANIZATION',
            widgetConfig: {
                widgetConfigType: 'ORGANIZATION_INDICATORS_PER_SDG_WIDGET',
                acronym: 'ORGANIZATION_INDICATORS_PER_SDG_WIDGET',
                title: t('Organization Indicators Per SDG Widget'),
                row: 7,
                column: 1,
                width: 8,
                height: 3,
                extraFields: {
                    minHeight: 1,
                    widgetStyles: {
                        backgroundColor: 'transparent',
                        borderRadius: '16px',
                        height: '600px'
                    }
                }
            },
            organizationUUID: loginData.loggedOrganizationUuid,
        },
    ];

    return (
        <div className='a2030-briefing-page'>
            <DashboardGrid rows={9} columns={8} widgets={widgetsData} rowHeight={100} className={'a2030-briefing-dashb'}
                horizontalGap={20} verticalGap={20}
                horizontalPadding={0} verticalPadding={15}
            />
        </div>
    );
}

export default A2030BriefingPage;